import {FC, RefObject} from 'react';
import {Scalars} from '.cache/__types__';
import {SendMessageButtonProps} from '@pageComponents/Detail/SendMessageButton';
import {Carousel} from '@liveComponents/Carousel';
import NoImagePlaceholder from 'public/images/default_foto_main.jpg';
import {Section} from '@components/Section';

export type GalleryProps = {
    advert: {
        id: Scalars['ID'];
        publicImages: {
            id: Scalars['ID'];
            size?: {
                width: number;
                height: number;
            };
            url: string;
        }[];
        messageData: SendMessageButtonProps['messageData'];
    };
    sendMessageButtonRef?: RefObject<HTMLButtonElement>;
};

export const Gallery: FC<GalleryProps> = ({advert, sendMessageButtonRef}) => {
    const images = advert.publicImages;

    return (
        <Section centerDrawnBackground className="mb-6 mb-lg-23">
            {images.length === 0 && <Carousel id={advert.id} images={NoImagePlaceholder} />}

            {images.length > 0 && (
                <Carousel
                    id={advert.id}
                    images={images}
                    messageData={advert.messageData}
                    sendMessageButtonRef={sendMessageButtonRef}
                />
            )}
        </Section>
    );
};
